export default {"src":"/_next/static/media/company.d71f118b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};